import styled from "styled-components";
import {LiveCasinoGridItemClosedMessageDefaultBox} from "./live-casino-grid-item-closed-message.default.box";

export const LiveCasinoGridItemClosedMessageCasino777Box = styled(LiveCasinoGridItemClosedMessageDefaultBox)`
  &::after {
    background: linear-gradient(90deg, transparent, ${props => props.theme.colors.brandSecondaryDark} 33%, ${props => props.theme.colors.brandSecondaryDark} 67%, transparent);
  }
`;
